var impressum = "النشر";
var privacy = "الخصوصية والبنود القانونية";
var recallInfo = "معلومات الاستدعاء";
var signOut = "تسجيل الخروج";
var ar_sa = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { ar_sa as default, impressum, privacy, recallInfo, signOut };
